import variables from './variables';

export default function () {

    function displayNotification(title, message, url) {
        let options = {
            body: message,
            icon: variables.baseUrl + 'assets/dist/img/icon.png',
			tag: title
        };
		const notification = new Notification(title, options);
		if (url) {
			notification.onclick = function () {
				window.open(url);
			};
		}
    }

    // Pusher.logToConsole = true;
    window.pusher = new Pusher(process.env.PUSHER_APP_KEY, {
        cluster: 'ap1',
        encrypted: true
    });

    if (variables.userId && typeof Pusher !== 'undefined') {
        if ('Notification' in window) {
            if (Notification.permission !== "granted") {
                Notification.requestPermission(function (result) {
                    console.log('User choice', result);
                    if (result !== 'granted') {
                        console.log('No notification permission granted');
                    } else {
                        displayNotification('Successfully subscribed!', 'You successfully subscribe to our notification service!');
                    }
                });
            } else {
                const channelApplicant = pusher.subscribe('applicant-' + variables.userId);
                channelApplicant.bind('applicant', function (data) {
                    displayNotification('New User Application', data.message, data.url);
                });

                const channelEmployee = pusher.subscribe('employee-' + variables.userId);
				channelEmployee.bind('employee-request', function (data) {
                    displayNotification('Employee Request', data.message, data.url);
                });

				channelEmployee.bind('employee', function (data) {
                    displayNotification('New Employee', data.message, data.url);
                });

                const channelSchedule = pusher.subscribe('schedule-' + variables.userId);
				channelSchedule.bind('change-shift', function (data) {
                    displayNotification('Change Shift', data.message, data.url);
                });
            }
        } else {
            console.log('Not support notification');
        }
    }

};
